import * as React from 'react'
import { RouteComponentProps, Switch, useRouteMatch } from 'react-router-dom'
import CompetencyTest from '../pages/competency-test/competency-test'
import { AuthedRoutes } from '../components/AuthedRoutes'
import Detail from "../pages/competency-test/detail";
import TestDetail from "../pages/competency-test/test-detail";
import CompetencyCat from "../pages/competency-test/competency-cat";
import CompetencyReview from "../pages/competency-test/review";
export const competencyTestRoutes = (props: RouteComponentProps) =>{
	// eslint-disable-next-line react-hooks/rules-of-hooks
	let { path } = useRouteMatch();
	return (
    <>
      <Switch>
        <AuthedRoutes
          menu="competency"
          path={`${path}/`}
          exact={true}
          component={CompetencyTest}
          headerTitle="Daftar Asesmen"
          showBreadcrumb={false}
        ></AuthedRoutes>
        <AuthedRoutes
          menu="competency"
          path={`${path}/cat/:cat`}
          exact={true}
          component={CompetencyCat}
          headerTitle="Detail Asesmen"
          showBreadcrumb={false}
        ></AuthedRoutes>
        <AuthedRoutes
          menu="competency"
          path={`${path}/:id/review`}
          exact={true}
          component={CompetencyReview}
          headerTitle="Pembahasan Asesmen"
          showBreadcrumb={true}
          noPadding
        ></AuthedRoutes>
        <AuthedRoutes
          menu="competency"
          path={`${path}/:id`}
          exact={true}
          component={Detail}
          headerTitle="Detail Asesmen"
          showBreadcrumb={true}
          noPadding
        ></AuthedRoutes>
        <AuthedRoutes
          menu="competency"
          path={`${path}/:id/test`}
          exact={true}
          component={TestDetail}
          excludeHeader={true}
          excludeBottom={true}
          noPadding
          headerTitle="Asesmen"
        ></AuthedRoutes>
      </Switch>
    </>
  );
}

